// Sneak Peek im Portwein-Adventskalender: Ein Klick auf das Overlay mit dem Auge
// hellt den Kalender auf, öffnet zufällige Türchen einen Spalt und blendet die
// Vorschau-Portweine ein. Welcher Portwein hinter welchem Türchen steckt, wird
// bewusst nicht verraten. Ein Textlink darunter schliesst alles wieder.
class PwkSneakPeek extends HTMLElement {
  connectedCallback() {
    this.veil = this.querySelector('[data-peek-toggle]');
    this.closeButton = this.querySelector('[data-peek-close]');
    this.panel = this.querySelector('[data-peek-panel]');
    this.doors = Array.from(this.querySelectorAll('[data-peek-door]'));
    if (!this.veil || !this.panel) return;

    this.veil.addEventListener('click', () => this.setOpen(true));
    this.closeButton?.addEventListener('click', () => this.setOpen(false));
  }

  setOpen(open) {
    this.veil.setAttribute('aria-expanded', String(open));
    this.veil.tabIndex = open ? -1 : 0;
    this.veil.toggleAttribute('aria-hidden', open);
    this.classList.toggle('is-open', open);
    this.panel.hidden = !open;
    if (this.closeButton) this.closeButton.hidden = !open;

    this.doors.forEach((door) => door.classList.remove('is-ajar'));
    if (open) {
      this.randomDoors(Number(this.dataset.peekCount) || 4).forEach((door) => door.classList.add('is-ajar'));
      this.closeButton?.focus({ preventScroll: true });
    } else {
      this.veil.focus({ preventScroll: true });
    }
  }

  randomDoors(count) {
    const pool = [...this.doors];
    for (let i = pool.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    return pool.slice(0, count);
  }
}

if (!customElements.get('pwk-sneak-peek')) customElements.define('pwk-sneak-peek', PwkSneakPeek);
